import { useEffect, useRef } from 'react';
import { Household } from '../../../types/global';
import { CardLayout } from '../../../shared/components';
import { getHouseholdKey, getHouseholdsText } from '../utils';

export type HouseholdMarkerCardProps = {
  households: readonly Household[],
  setClickedMarker: (marker: null) => void;
  onSelectHousehold: (household: Household) => void;
  returnFocusTo?: Household | null;
};

export default function HouseholdMarkerCard({
  households, setClickedMarker, onSelectHousehold, returnFocusTo = null,
}: Readonly<HouseholdMarkerCardProps>) {
  const householdCount = households.length;
  const householdsText = getHouseholdsText(householdCount);
  const returnFocusRef = useRef<HTMLButtonElement>(null);
  const returnFocusKey = returnFocusTo ? getHouseholdKey(returnFocusTo) : null;

  useEffect(() => {
    returnFocusRef.current?.focus();
  }, []);
  return (
    <CardLayout title={householdsText} onClose={() => setClickedMarker(null)}>
      <ul
        id="tooltip-household-references"
        className="p-2 max-h-48 overflow-y-auto"
        onWheelCapture={(event) => event.stopPropagation()}
      >
        {households.map((household) => (
          <li key={getHouseholdKey(household)}>
            <button
              ref={getHouseholdKey(household) === returnFocusKey ? returnFocusRef : undefined}
              type="button"
              className="text-body-regular text-secondary underline cursor-pointer"
              onClick={() => onSelectHousehold(household)}
            >
              {household.householdReference}
            </button>
          </li>
        ))}
      </ul>
    </CardLayout>
  );
}
